import React from 'react';
import styles from './index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWrench, faClock, faMobile, faLockOpen, faUser, faPhoneAlt, faDollarSign, faMoneyBill } from '@fortawesome/free-solid-svg-icons';

// Components
import { Card, Col, Row } from 'react-bootstrap';

// Functions
import hreadableDate from '../../../functions/hreadableDate';
import readablePhone from '../../../functions/readablePhone';

const OrderInfo = (props) => (
    <div className={styles.Info}>
        <h5>{props.title}</h5>
        <p>
            <FontAwesomeIcon icon={props.icon} className={styles.Info__icon} />
            <span>{props.value}</span>
        </p>
    </div>
);

const Order = (props) => (
    <>
        {props.order ? <Card className={styles.Order}>
            <Row>
                <Col>
                    <OrderInfo title="Trabajo" value={props.order.service} icon={faWrench} />
                </Col>
                <Col>
                    <OrderInfo title="Fecha de Entrada" value={hreadableDate(props.order.timestamp, true, true)} icon={faClock} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <OrderInfo title="Dipositivo" value={props.order.device.name} icon={faMobile} />
                </Col>
                <Col>
                    {props.order.device.password && <OrderInfo title="Contraseña" value={props.order.device.password} icon={faLockOpen} />}
                </Col>
            </Row>
            <Row>
                <Col>
                    <OrderInfo title="Cliente" value={props.order.client.name} icon={faUser} />
                </Col>
                {props.order.client.phone && <Col>
                    <OrderInfo title="Telefono" value={readablePhone(props.order.client.phone)} icon={faPhoneAlt} />
                </Col>}
            </Row>
            {props.order.notes && <div className={styles.Info}>
                <h5>Notas</h5>
                <p>{props.order.notes}</p>
            </div>}
            <hr />
            <Row>
                <Col>
                    <OrderInfo title="Total" value={`$${props.order.total.toFixed(2)}`} icon={faDollarSign} />
                </Col>
                <Col>
                    <OrderInfo title="Debe" value={`$${(props.order.total - props.order.paid) >= 0 ? (props.order.total - props.order.paid).toFixed(2) : '0.00'}`} icon={faMoneyBill} />
                </Col>
            </Row>
        </Card> : <div>Esperando la orden que cargue</div>}
    </>
);

export default Order;